/**
 * 1.7.8 — the day bends: every call the screens make (shared/day-bend.ts has the shapes and the rules).
 * A move or a booking that would run into the next visit is answered 409 `overlap` with the choices: `overlapOf`
 * reads them out of the refusal, and the press is made again with `onOverlap`.
 */
import { apiFetch, ApiRequestError } from '@/lib/api';
import type { DayStartRequest, DayStartResponse, OverlapAnswer } from '@shared/day-bend';

/** Move within today: the planned slot becomes the chosen time (administrator, co-administrator, scheduler). */
export function moveInDayReq(body: DayStartRequest): Promise<DayStartResponse> {
  return apiFetch<DayStartResponse>('/api/housekeeping/day-start', { method: 'POST', body: JSON.stringify(body) });
}

/** "Email the tenant their new time" for a visit whose time changed today: one press, one tenant, into the Outbox. */
export function tellNewTimeReq(appointmentId: string): Promise<{ communicationId: string | null; status: string; scheduledAt: string | null }> {
  return apiFetch('/api/housekeeping/day-start/tell', { method: 'POST', body: JSON.stringify({ appointmentId }) });
}

/** The choices a refusal carries when the press would run into the next visit; null for any other error. */
export function overlapOf(e: unknown): OverlapAnswer | null {
  const body = e instanceof ApiRequestError ? (e.body as unknown as Partial<OverlapAnswer> | null) : null;
  return body?.error === 'overlap' && body.overlap ? (body as OverlapAnswer) : null;
}
